import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  useMediaQuery,
  Button,
  CardMedia,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React, { useContext, useEffect, useState } from "react";
import image from "../../../assets/images/detail/image.png";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { styled } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { _DecryptService } from "../../../service/EncryptDecryptService";
import _JWTDecodeService from "../../../service/JWTDecodeService";
import theme from "../../../theme";
import AlertBoxComponent from "../../Alert/AlertBoxComponent";
import { AddToCartAPI } from "../../../api/product/ProductController";
import { CartContext } from "../../../context/CartContext";
import { toast } from "react-toastify";
import outOfStockImage from "../../../assets/images/OutOfStock.png";

// Styled Radio Button
const StyledRadioButton = styled(Button)(({ theme, selected }) => ({
  height: "60px",
  borderRadius: "50%",
  border: selected
    ? `2px solid ${theme.palette.primary.main}`
    : `1px solid ${theme.palette.primary.main}`,
  backgroundColor: selected ? theme.palette.primary.light : "#f9f9f9",
  color: selected ? theme.palette.primary.contrastText : "#333",
  textTransform: "none",
  fontSize: "1rem",
  display: "flex",
  fontWeight: "700",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: selected ? theme.palette.primary.main : "#e0e0e0",
  },
}));

const DetailCardComponent = ({ item, history }) => {
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const isMobile = useMediaQuery("(max-width:600px)");
  const [unitCategories, setUnitCategories] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [unitLoading, setUnitLoading] = useState(false);
  const [unitMultiplierMap, setUnitMultiplierMap] = useState({});
  const availableSizes =
    typeof item?.size === "string"
      ? item.size
          .split(",")
          .map((value) => value.trim())
          .filter(Boolean)
      : [];
  const availableColors =
    typeof item?.color === "string"
      ? item.color
          .split(",")
          .map((value) => value.trim())
          .filter(Boolean)
      : [];
  const availableMaterials =
    typeof item?.materials === "string"
      ? item.materials
          .split(",")
          .map((value) => value.trim())
          .filter(Boolean)
      : [];
  const [descriptionExpanded, setDescriptionExpanded] = useState(true);
  const [wayOfUseExpanded, setWayOfUseExpanded] = useState(false);
  const [sizeExpanded, setSizeExpanded] = useState(false);
  const [mainImageIndex, setMainImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(100);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [textLoading, setTextLoading] = useState(false);
  const { setCartItemCount } = useContext(CartContext);
  const [showMessage, setShowMessage] = useState(false);
  const [stockWarning, setStockWarning] = useState("");
  const productDescription =
    typeof item?.productDescription === "string" ? item.productDescription : "";
  const wayOfUseKeywordMatch = productDescription.match(
    /(အသုံးပြုနည်း|way\s*of\s*use)/i
  );
  const hasWayOfUseSection = Number.isInteger(wayOfUseKeywordMatch?.index);
  const wayOfUseStartIndex = hasWayOfUseSection
    ? wayOfUseKeywordMatch.index + wayOfUseKeywordMatch[0].length
    : -1;
  const descriptionText = hasWayOfUseSection
    ? productDescription.slice(0, wayOfUseKeywordMatch.index).trim()
    : productDescription;
  const wayOfUseText = hasWayOfUseSection
    ? productDescription
        .slice(wayOfUseStartIndex)
        .replace(/^[\s:：\-|]+/, "")
        .trim()
    : "";

  useEffect(() => {
    const fetchUnitCategories = async () => {
      setUnitLoading(true);
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(
          process.env.REACT_APP_RESOURCE_ENDPOINT +
            "UnitCategory.json?t=" +
            timestamp
        );
        const unitCategoriesData = await response.json();

        const businessName =
          item?.businessName || item?.dataLst?.[0]?.businessName || "";
        let unitCategoryList = [];
        let multiplierMap = {};
        if (Array.isArray(unitCategoriesData)) {
          const filtered = businessName
            ? unitCategoriesData.filter(
                (unit) =>
                  unit?.businessName === businessName &&
                  unit?.isActive === true
              )
            : unitCategoriesData.filter((unit) => unit?.isActive === true);
          unitCategoryList = filtered
            .map((unit) => unit?.title)
            .filter(Boolean);
          multiplierMap = filtered.reduce((acc, unit) => {
            const title = unit?.title;
            const multiplier = Number(unit?.conversion?.multiplier);
            if (title && Number.isFinite(multiplier)) {
              acc[title] = multiplier;
            }
            return acc;
          }, {});
        } else if (Array.isArray(unitCategoriesData?.Categories)) {
          unitCategoryList = unitCategoriesData.Categories;
        }

        const uniqueUnitTitles = Array.from(new Set(unitCategoryList));
        setUnitCategories(uniqueUnitTitles);
        setUnitMultiplierMap(multiplierMap);
        const nextDefault = uniqueUnitTitles[0] || "";
        setSelectedUnit((prev) =>
          prev && uniqueUnitTitles.includes(prev) ? prev : nextDefault
        );
      } catch (error) {
        console.error("Error fetching unit categories:", error);
      } finally {
        setUnitLoading(false);
      }
    };

    fetchUnitCategories();
  }, [item]);

  const handleToggle = (setExpandedName) => {
    setExpandedName((prev) => !prev);
  };

  const parseAvailableQuantity = (product) => {
    const rawValue =
      product?.quantity ??
      product?.Quantity ??
      product?.availableQuantity ??
      product?.availableQty ??
      product?.qty ??
      product?.Qty ??
      product?.stockQty ??
      product?.stock ??
      product?.Stock;
    const numericValue =
      typeof rawValue === "string"
        ? Number(rawValue.replace(/,/g, ""))
        : Number(rawValue);
    return Number.isFinite(numericValue) ? numericValue : NaN;
  };

  const getUnitMultiplier = (unitTitle) => {
    if (!unitTitle) {
      return 1;
    }
    const mappedMultiplier = unitMultiplierMap?.[unitTitle];
    if (Number.isFinite(mappedMultiplier)) {
      return mappedMultiplier;
    }
    const lower = String(unitTitle).toLowerCase();
    if (lower.includes("dozen")) {
      return 12;
    }
    const numberMatch = lower.match(/(\d+)/);
    if (
      numberMatch &&
      (lower.includes("pc") ||
        lower.includes("pcs") ||
        lower.includes("piece") ||
        lower.includes("unit") ||
        lower.includes("pack") ||
        lower.includes("box"))
    ) {
      return Number(numberMatch[1]) || 1;
    }
    return 1;
  };

  const parseUnitQuantities = (priceValue) => {
    if (typeof priceValue !== "string") {
      return {};
    }
    return priceValue.split(",").reduce((acc, entry) => {
      const trimmedEntry = entry.trim();
      if (!trimmedEntry) {
        return acc;
      }
      const [title, , quantityText = ""] = trimmedEntry
        .split("-")
        .map((part) => part.trim());
      const numericQuantity = Number(quantityText.replace(/,/g, ""));
      if (title && Number.isFinite(numericQuantity)) {
        acc[title.trim()] = numericQuantity;
      }
      return acc;
    }, {});
  };

  const validateStock = () => {
    const unitStockMap = parseUnitQuantities(item?.price);
    const selectedUnitStock =
      selectedUnit && Number.isFinite(unitStockMap[selectedUnit])
        ? unitStockMap[selectedUnit]
        : NaN;
    if (Number.isFinite(selectedUnitStock)) {
      if (quantity > selectedUnitStock) {
        setStockWarning("Insufficient quantity and reduce your quantity");
        return false;
      }
      setStockWarning("");
      return true;
    }
    const availableQty = parseAvailableQuantity(item);
    if (!Number.isFinite(availableQty)) {
      setStockWarning("");
      return true;
    }
    const multiplier = getUnitMultiplier(selectedUnit);
    const requestedQty = quantity * multiplier;
    if (requestedQty > availableQty) {
      setStockWarning("Insufficient quantity and reduce your quantity");
      return false;
    }
    setStockWarning("");
    return true;
  };

  const parseUnitPrices = (priceValue) => {
    if (typeof priceValue !== "string") {
      return {};
    }
    return priceValue.split(",").reduce((acc, entry) => {
      const trimmedEntry = entry.trim();
      if (!trimmedEntry) {
        return acc;
      }
      const [title, priceText = ""] = trimmedEntry
        .split("-")
        .map((part) => part.trim());
      const numericText = priceText.replace(/,/g, "").replace(/[^\d.]/g, "");
      const numericValue = Number(numericText);
      if (title && !Number.isNaN(numericValue)) {
        acc[title.trim()] = numericValue;
      }
      return acc;
    }, {});
  };

  const resolveUnitPrice = (priceValue, unitTitle) => {
    if (typeof priceValue === "number") {
      return priceValue;
    }
    if (typeof priceValue === "string") {
      if (!priceValue.includes("-")) {
        const numericText = priceValue.replace(/,/g, "").replace(/[^\d.]/g, "");
        const numericValue = Number(numericText);
        return Number.isNaN(numericValue) ? NaN : numericValue;
      }
      const unitMap = parseUnitPrices(priceValue);
      if (unitTitle && unitMap[unitTitle] != null) {
        return unitMap[unitTitle];
      }
      const fallbackUnit = Object.keys(unitMap)[0];
      if (fallbackUnit) {
        return unitMap[fallbackUnit];
      }
    }
    return NaN;
  };

  const handleBuy = async (item) => {
    try {
      const userToken = sessionStorage.getItem("token");
      let userId = "";
      if (userToken) {
        userId = _DecryptService(
          _JWTDecodeService(_DecryptService(userToken)).UserId
        );
      }
      const businessName =
        item?.businessName || item?.dataLst?.[0]?.businessName || "";

      // Validate color & size selection
      if (
        (availableColors.length > 0 && !selectedColor) ||
        (availableSizes.length > 0 && !selectedSize)
      ) {
        setOpen(true);
        return;
      }

      if (!validateStock()) {
        return;
      }

      console.log("Proceeding to Buy:", item);

      const isNumericPriceString =
        typeof item?.price === "string" &&
        !item.price.includes("-") &&
        !Number.isNaN(Number(item.price.replace(/,/g, "")));
      const fallbackUnit =
        isNumericPriceString && unitCategories.length > 0
          ? unitCategories[0]
          : "";
      const effectiveUnit = selectedUnit || fallbackUnit;
      const unitPrice = resolveUnitPrice(item.price, effectiveUnit);
      const amount = Number.isNaN(unitPrice) ? 0 : unitPrice * quantity;

      // Prepare order data
      const data = {
        cartId: "",
        userId: userId,
        productCode: item.productCode,
        productId: item.productId,
        productName: item.productTitle,
        unitPrice: unitPrice,
        quantity: quantity,
        Amount: amount,
        color: selectedColor,
        size: selectedSize,
        materials: item.materials,
        businessName: businessName,
        Unit: effectiveUnit,
        UnitTitle: effectiveUnit,
      };

      // Redirect to payment page
      history.push({
        pathname: "/payment",
        state: { formData: data, total: data.Amount },
      });
    } catch (error) {
      console.error("Error in handleBuy:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleAddToCart = async (item) => {
    console.log("productCode", item.productCode);
    try {
      setTextLoading(true);
      const userToken = sessionStorage.getItem("token");
      if (!userToken) {
        toast.warning("Please login to add to cart");
        return;
      }

      const userId = _DecryptService(
        _JWTDecodeService(_DecryptService(userToken)).UserId
      );

      if (
        (availableColors.length > 0 && !selectedColor) ||
        (availableSizes.length > 0 && !selectedSize)
      ) {
        setOpen(true);
        return;
      }

      if (!validateStock()) {
        return;
      }

      const data = {
        UserId: userId,
        ProductCode: item.productCode,
        ProductId: item.productId,
        Color: selectedColor,
        Size: selectedSize,
        Materials: item.materials,
        Quantity: quantity,
      };
      const response = await AddToCartAPI(data, setLoading, toast);
      if (response.baseResponseModel.respCode === 200) {
        setCartItemCount(response.cartItemCount);
        setShowMessage(true);
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    } finally {
      setTextLoading(false);
    }
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US").format(number);
  };

  const getSellablePriceEntries = (priceValue) => {
    if (typeof priceValue !== "string" || !priceValue.includes("-")) {
      return [];
    }
    return priceValue
      .split(",")
      .map((entry) => entry.trim())
      .filter(Boolean)
      .map((entry) => {
        const [title = "", priceText = "", quantityText = ""] = entry
          .split("-")
          .map((part) => part.trim());
        const parsedPrice = Number(
          String(priceText).replace(/MMK/gi, "").replace(/,/g, "").trim()
        );
        const parsedQty = Number(String(quantityText).replace(/,/g, "").trim());
        const hasQty = quantityText !== "" && !Number.isNaN(parsedQty);
        const hasPositiveQty = hasQty ? parsedQty > 0 : true;
        const hasPositivePrice = !Number.isNaN(parsedPrice) ? parsedPrice > 0 : true;
        return {
          raw: entry,
          title: (title || "").trim(),
          priceText: (priceText || "").trim(),
          quantityText: (quantityText || "").trim(),
          isSellable: hasPositiveQty && hasPositivePrice,
        };
      })
      .filter((entry) => entry.title && entry.isSellable);
  };

  const renderPriceDisplay = (priceValue) => {
    if (typeof priceValue === "string" && priceValue.includes("-")) {
      const entries = getSellablePriceEntries(priceValue);
      return entries.map((entry, index) => {
        const suffix = index < entries.length - 1 ? "," : "";
        return (
          <span key={`${entry.raw}-${index}`} style={{ display: "block" }}>
            {`${entry.title} - ${entry.priceText} MMK${suffix}`}
          </span>
        );
      });
    }
    const numericValue =
      typeof priceValue === "number"
        ? priceValue
        : typeof priceValue === "string" && priceValue.trim() !== ""
          ? Number(priceValue)
          : NaN;
    if (!Number.isNaN(numericValue)) {
      return `${formatNumber(numericValue)} MMK`;
    }
    return priceValue || "";
  };

  const getUnitsFromPrice = (priceValue) => {
    return getSellablePriceEntries(priceValue).map((entry) => entry.title);
  };

  const isAllUnitStockZero = () => {
    if (typeof item?.price !== "string" || !item.price.includes("-")) {
      return false;
    }
    const entries = item.price
      .split(",")
      .map((entry) => entry.trim())
      .filter(Boolean);
    if (entries.length === 0) {
      return false;
    }
    const quantities = entries
      .map((entry) => {
        const [, , quantityText = ""] = entry.split("-").map((part) => part.trim());
        const parsedQuantity = Number(String(quantityText).replace(/,/g, "").trim());
        return Number.isNaN(parsedQuantity) ? null : parsedQuantity;
      })
      .filter((qty) => qty != null);
    if (quantities.length === 0) {
      return false;
    }
    return quantities.every((qty) => qty <= 0);
  };

  const showOutOfStockImage = isAllUnitStockZero();
  const getImageUrl = (item, index) => {
    if (!item?.dataLst || !item.dataLst[index]) {
      return "";
    }

    const baseEndpoint =
      process.env.REACT_APP_RESOURCE_ENDPOINT ||
      process.env.REACT_APP_RESOURCE_ENDPOINT;
    const productId = item.dataLst[index].product_Id;
    const imageName = item.dataLst[index].image;
    const businessName = item.dataLst[index].businessName;

    if (!baseEndpoint || !productId || !imageName) {
      return "";
    }
    console.log(
      `${baseEndpoint}/Upload/Ecommerce/${businessName}/${productId}/${imageName}`
    );
    return `${baseEndpoint}/Upload/Ecommerce/${businessName}/${productId}/${imageName}`;
  };

  const handleQuantityChange = (action) => {
    setQuantity((prevQuantity) =>
      action === "increase" ? prevQuantity + 1 : Math.max(1, prevQuantity - 1)
    );
  };

  useEffect(() => {
    validateStock();
  }, [quantity, selectedUnit, item]);

  useEffect(() => {
    const priceUnits = getUnitsFromPrice(item?.price);
    const hasUnitPriceFormat =
      typeof item?.price === "string" && item.price.includes("-");
    const availableUnits =
      hasUnitPriceFormat
        ? unitCategories.filter((unit) => priceUnits.includes(unit))
        : unitCategories;
    if (availableUnits.length === 0) {
      if (selectedUnit !== "") {
        setSelectedUnit("");
      }
      return;
    }
    if (!availableUnits.includes(selectedUnit)) {
      setSelectedUnit(availableUnits[0]);
    }
  }, [item?.price, unitCategories, selectedUnit]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: { xs: "12px 16px 24px", sm: "16px", md: "20px" },
      }}
    >
      <AlertBoxComponent
        open={open}
        onClose={() => setOpen(false)}
        title="Choose Your Perfect Fit"
        messageParts={[
          { text: "To ensure the perfect choice, please choose both a " },
          { text: "color", color: "#F98C6B", bold: true },
          { text: " and a " },
          { text: "size", color: "#6B7BF9", bold: true },
          { text: " before proceeding." },
        ]}
      />
      <Box
        sx={{
          width: { xs: "100%", sm: "92%", md: "80%", lg: "70%" },
          maxWidth: "1200px",
          height: "auto",
          margin: { xs: "8px auto 0", sm: "20px auto" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: "16px", md: "8%", lg: "12%" },
            justifyContent: "center",
            alignItems: { xs: "stretch", md: "center" },
          }}
        >
          {/* Left: Image Section */}
          <Card
            sx={{
              width: { xs: "100%", sm: "90%", md: "40%", lg: "35%" },
              backgroundColor: "transparent",
              boxShadow: "none",
              position: "relative",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between", // Align thumbnails and image evenly
              alignSelf: { xs: "center", md: "flex-start" },
            }}
          >
            <Box
              sx={{
                flex: isMobile ? "1" : "0 0 50%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Main Image */}
              <Card
                sx={{
                  width: isMobile ? "90%" : "100%",
                  height: "auto",
                  overflow: "hidden",
                  borderRadius: "8px",
                  position: "relative",
                  cursor: "zoom-in",
                }}
              >
                <CardMedia
                  component="img"
                  image={
                    showOutOfStockImage
                      ? outOfStockImage
                      : getImageUrl(item, mainImageIndex)
                  }
                  alt={`Main Image ${mainImageIndex}`}
                  loading={mainImageIndex === 0 ? "eager" : "lazy"}
                  decoding="async"
                  fetchpriority={mainImageIndex === 0 ? "high" : "auto"}
                  sx={{
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                    maxHeight: { xs: 260, sm: 360, md: 500 },
                    justifyContent: "center",
                    alignSelf: "center",
                  }}
                />
              </Card>

              {/* Thumbnails */}
              {!showOutOfStockImage && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "relative",
                    width: "100%",
                    marginTop: "6px",
                  }}
                >
                {/* Backward Icon */}
                <IconButton
                  onClick={() =>
                    mainImageIndex > 0 && setMainImageIndex((prev) => prev - 1)
                  }
                  disabled={mainImageIndex === 0}
                  sx={{
                    zIndex: 1,
                    backgroundColor:
                      mainImageIndex > 0
                        ? theme.palette.primary.main
                        : "transparent",
                    color: mainImageIndex > 0 ? "#fff" : "rgba(0, 0, 0, 0.2)",
                    "&:hover": {
                      backgroundColor:
                        mainImageIndex > 0
                          ? "rgba(0, 0, 0, 0.7)"
                          : "transparent",
                    },
                  }}
                >
                  <ArrowBackIosIcon />
                </IconButton>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    overflow: "hidden",
                    width: "100%",
                  }}
                >
                  {item.dataLst?.map((_, index) => (
                    <Card
                      key={index}
                      onClick={() => setMainImageIndex(index)}
                      sx={{
                        width: { xs: "48px", sm: "56px", md: "60px" },
                        height: { xs: "48px", sm: "56px", md: "60px" },
                        cursor: "pointer",
                        border:
                          mainImageIndex === index
                            ? "2px solid #F98C6B"
                            : "1px solid #ccc",
                        borderRadius: "4px",
                        overflow: "hidden",
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={getImageUrl(item, index)}
                        alt={`Thumbnail ${index}`}
                        loading="lazy"
                        decoding="async"
                        sx={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  ))}
                </Box>

                {/* Forward Icon */}
                <IconButton
                  onClick={() =>
                    mainImageIndex < item?.dataLst?.length - 1 &&
                    setMainImageIndex((prev) => prev + 1)
                  }
                  disabled={mainImageIndex === item?.dataLst?.length - 1}
                  sx={{
                    zIndex: 1,
                    backgroundColor:
                      mainImageIndex < item.dataLst?.length - 1
                        ? theme.palette.primary.main
                        : "transparent",
                    color:
                      mainImageIndex < item?.dataLst?.length - 1
                        ? "#fff"
                        : "rgba(0, 0, 0, 0.2)",
                    "&:hover": {
                      backgroundColor:
                        mainImageIndex < item?.dataLst?.length - 1
                          ? "rgba(0, 0, 0, 0.7)"
                          : "transparent",
                    },
                  }}
                >
                  <ArrowForwardIosIcon />
                </IconButton>
                </Box>
              )}
            </Box>
          </Card>

          {/* Right: Details Section */}
          <Box
            sx={{
              width: { xs: "100%", md: "55%" },
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              justifyContent: "center",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <Typography
                sx={{ fontSize: isMobile ? "20px" : "25px", fontWeight: "700" }}
              >
                {item.productTitle}
              </Typography>
              <Typography>{renderPriceDisplay(item.price)}</Typography>
              {availableSizes.length > 0 && (
                <>
                  <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                    Available Sizes
                  </Typography>
                  <RadioGroup
                    name="size-group"
                    value={selectedSize}
                    row
                    sx={{
                      justifyContent: "flex-start",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}
                  >
                    {availableSizes.map((size) => (
                      <FormControlLabel
                        key={size}
                        value={size}
                        control={<Radio sx={{ display: "none" }} />}
                        label={
                          <StyledRadioButton
                            selected={selectedSize === size}
                            onClick={() => setSelectedSize(size)}
                          >
                            {size}
                          </StyledRadioButton>
                        }
                      />
                    ))}
                  </RadioGroup>
                </>
              )}

              {/* Available Colors */}
              {availableColors.length > 0 && (
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
                >
                  <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                    Available Colors
                  </Typography>
                  <RadioGroup
                    name="color-group"
                    value={selectedColor}
                    row
                    sx={{
                      justifyContent: "flex-start",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}
                  >
                    {availableColors.map((color) => (
                      <FormControlLabel
                        key={color}
                        value={color}
                        control={<Radio sx={{ display: "none" }} />}
                        label={
                          <StyledRadioButton
                            selected={selectedColor === color}
                            onClick={() => setSelectedColor(color)}
                          >
                            {color}
                          </StyledRadioButton>
                        }
                      />
                    ))}
                  </RadioGroup>
                </Box>
              )}

              {/* Quantity Selector */}
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
              >
                {unitCategories.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      maxWidth: "220px",
                    }}
                  >
                    <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                      Unit
                    </Typography>
                    <FormControl size="small" fullWidth>
                      <Select
                        value={selectedUnit}
                        onChange={(event) => setSelectedUnit(event.target.value)}
                      >
                        {(() => {
                          const priceUnits = getUnitsFromPrice(item?.price);
                          const hasUnitPriceFormat =
                            typeof item?.price === "string" &&
                            item.price.includes("-");
                          const baseUnits =
                            hasUnitPriceFormat
                              ? unitCategories.filter((unit) =>
                                  priceUnits.includes(unit)
                                )
                              : unitCategories;
                          return baseUnits.map((unitTitle) => (
                            <MenuItem key={unitTitle} value={unitTitle}>
                              {unitTitle}
                            </MenuItem>
                          ));
                        })()}
                      </Select>
                    </FormControl>
                  </Box>
                )}
                <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                  Quantity
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: "10px", sm: "15px" },
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <IconButton
                    style={{
                      borderRadius: 20,
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                    }}
                    size="small"
                    onClick={() => handleQuantityChange("increase")}
                  >
                    <AddIcon />
                  </IconButton>
                  <Typography sx={{ color: theme.palette.text.main }}>
                    {quantity}
                  </Typography>
                  <IconButton
                    style={{
                      borderRadius: 20,
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                    }}
                    size="small"
                    onClick={() => handleQuantityChange("decrease")}
                  >
                    <RemoveIcon />
                  </IconButton>
                </Box>
                {stockWarning && (
                  <Typography sx={{ color: "#d32f2f", fontSize: "14px" }}>
                    {stockWarning}
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <Button
                variant="contained"
                sx={{
                  color: theme.button.textColor.main,
                  backgroundColor: theme.button.backgroundColor.main,
                  height: "45px",
                  width: { xs: "100%", sm: "100%", md: "90%" },
                  alignSelf: { xs: "center", md: "flex-start" },
                  "&:hover": {
                    backgroundColor: theme.palette.hover.main,
                  },
                }}
                disabled={unitLoading || Boolean(stockWarning)}
                onClick={() => handleBuy(item)}
              >
                Buy it Now
              </Button>

              <Dialog
                open={showMessage}
                onClose={() => setShowMessage(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title"></DialogTitle>
                <DialogContent>
                  <Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <CheckCircleIcon
                        sx={{
                          color: theme.palette.primary.main,
                          marginRight: "10px",
                        }}
                      />
                      {item.productTitle} has been added to your cart.
                    </Box>
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      setShowMessage(false);
                    }}
                    color="primary"
                    autoFocus
                  >
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </Box>
        </Box>

        <Accordion
          expanded={descriptionExpanded}
          onChange={() => handleToggle(setDescriptionExpanded)}
          sx={{
            width: "100%",
            borderTop: "1px solid #d9d9d9", // Only top border
            borderBottom: "1px solid #d9d9d9", // Only bottom border
            borderLeft: "none", // No left border
            borderRight: "none", // No right border
            borderRadius: "0px", // Remove border radius
            boxShadow: "none",
            marginTop: "32px",
          }}
        >
          {/* Accordion Summary */}
          <AccordionSummary
            expandIcon={
              descriptionExpanded ? (
                <RemoveIcon sx={{ color: theme.palette.primary.main }} />
              ) : (
                <AddIcon sx={{ color: theme.palette.primary.main }} />
              )
            }
            aria-controls="description-content"
            id="description-header"
            sx={{
              backgroundColor: "#f9f9f9",
              padding: "10px 15px",
            }}
          >
            <Typography sx={{ fontWeight: "700", fontSize: "18px" }}>
              Description
            </Typography>
          </AccordionSummary>

          {/* Accordion Details */}
          <AccordionDetails
            sx={{
              padding: "15px",
              backgroundColor: "#ffffff",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <Typography>{descriptionText}</Typography>
          </AccordionDetails>
        </Accordion>
        {wayOfUseText && (
          <Accordion
            expanded={wayOfUseExpanded}
            onChange={() => handleToggle(setWayOfUseExpanded)}
            sx={{
              width: "100%",
              borderTop: "1px solid #d9d9d9",
              borderBottom: "1px solid #d9d9d9",
              borderLeft: "none",
              borderRight: "none",
              borderRadius: "0px",
              boxShadow: "none",
            }}
          >
            <AccordionSummary
              expandIcon={
                wayOfUseExpanded ? (
                  <RemoveIcon sx={{ color: theme.palette.primary.main }} />
                ) : (
                  <AddIcon sx={{ color: theme.palette.primary.main }} />
                )
              }
              aria-controls="way-of-use-content"
              id="way-of-use-header"
              sx={{
                backgroundColor: "#f9f9f9",
                padding: "10px 15px",
              }}
            >
              <Typography sx={{ fontWeight: "700", fontSize: "18px" }}>
                အသုံးပြုနည်း (Way of Use)
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: "15px",
                backgroundColor: "#ffffff",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <Typography>{wayOfUseText}</Typography>
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    </Box>
  );
};

export default DetailCardComponent;
